import React from 'react'

import { x } from 'utils/emotion'

const Flex = () => {
  return <x.div flex="1" />
}

export default React.memo(Flex)
